import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {
    Aangifte, AangifteBerekening,
    AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity, OpbouwInkomenBox1,
    OpbouwROW, SpecificatieROW
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';
import { CommandModule } from '@angular/cli/src/command-builder/command-module';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-overzicht-resultaat-overige-werkzaamheden',
  templateUrl: './overzicht-resultaat-overige-werkzaamheden.component.html',
  styleUrls: ['./overzicht-resultaat-overige-werkzaamheden.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule,
  ]
})
export class OverzichtResultaatOverigeWerkzaamhedenComponent implements OnInit {

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specROWFormGroup = this.fb.group<AangifteRapport>({});
    specROW = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specROWFormGroup = this.fb.group<AangifteRapport>(({
            specificatieROW: this.fb.group<SpecificatieROW>(({
                opbouw: this.fb.group<OpbouwROW>(({
                    berekendResultaatUitOverigeWerkzaamheden: null as unknown as number,
                    inkomstenUitOVerigeWerkzaamheden: null as unknown as number,
                    kostenTerZakeVanOverigeWerkzaamheden: null as unknown as number,
                    berekendResultaatTBS: null as unknown as number,
                    inkomstenUitTBS: null as unknown as number,
                    kostenTerZakeVanTBS: null as unknown as number,
                    tbsVrijstelling: null as unknown as number,
                    openingsbalansOG: null as unknown as number,
                    slotbalansOG: null as unknown as number,
                    openingsbalansOverig: null as unknown as number,
                    slotbalansOverig: null as unknown as number,
                    openingsbalansSchulden: null as unknown as number,
                    slotbalansSchulden: null as unknown as number,
                    openingsbalansEV: null as unknown as number,
                    slotbalansEV: null as unknown as number,
                } as OpbouwROW))
            } as SpecificatieROW))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    resultaatUitOverigeWerkzaamheden: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specROWFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.calculateTelling();
                    this.updateForm();
                    this.disableFormGroup(this.specROWFormGroup);
                    this.disableFormGroup(this.berekeningBox1FormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specROW = this.partnerRapport;
            this.specROWFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
        } else {
            this.specROW = this.aangifteRapport;
            this.specROWFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening)
        }
    }

    calculateTelling(): void {
        if (!this.partnerBoolean) {
            const ontvangenRow = this.aangifteRapport.specificatieROW?.opbouw?.inkomstenUitOVerigeWerkzaamheden?.valueOf() || 0;
            const kostenRow = this.aangifteRapport.specificatieROW?.opbouw?.kostenTerZakeVanOverigeWerkzaamheden?.valueOf() || 0;
            const saldoRow = ontvangenRow - kostenRow
            this.specROWFormGroup.get(['specificatieROW', 'opbouw', 'berekendResultaatUitOverigeWerkzaamheden'])?.patchValue(saldoRow);

            const ontvangenTBS = this.aangifteRapport.specificatieROW?.opbouw?.inkomstenUitTBS?.valueOf() || 0;
            const kostenTBS = this.aangifteRapport.specificatieROW?.opbouw?.kostenTerZakeVanTBS?.valueOf() || 0;
            const vrijstellingTBS = this.aangifteRapport.specificatieROW?.opbouw?.tbsVrijstelling?.valueOf() || 0;
            const saldoPU = ontvangenTBS - kostenTBS - vrijstellingTBS
            this.specROWFormGroup.get(['specificatieROW', 'opbouw', 'berekendResultaatTBS'])?.patchValue(saldoPU);
        } else {
            const ontvangenRow = this.partnerRapport.specificatieROW?.opbouw?.inkomstenUitOVerigeWerkzaamheden?.valueOf() || 0;
            const kostenRow = this.partnerRapport.specificatieROW?.opbouw?.kostenTerZakeVanOverigeWerkzaamheden?.valueOf() || 0;
            const saldoRow = ontvangenRow - kostenRow
            this.specROWFormGroup.get(['specificatieROW', 'opbouw', 'berekendResultaatUitOverigeWerkzaamheden'])?.patchValue(saldoRow);

            const ontvangenTBS = this.partnerRapport.specificatieROW?.opbouw?.inkomstenUitTBS?.valueOf() || 0;
            const kostenTBS = this.partnerRapport.specificatieROW?.opbouw?.kostenTerZakeVanTBS?.valueOf() || 0;
            const vrijstellingTBS = this.partnerRapport.specificatieROW?.opbouw?.tbsVrijstelling?.valueOf() || 0;
            const saldoPU = ontvangenTBS - kostenTBS - vrijstellingTBS
            this.specROWFormGroup.get(['specificatieROW', 'opbouw', 'berekendResultaatTBS'])?.patchValue(saldoPU);
        }
    }


    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

